var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-3 vx-row"},[_c('div',{staticClass:"w-full vx-col mb-base"},[_c('Table',{attrs:{"draw":_vm.draw,"status":_vm.tab,"sr-id":(this.selectedCode) ? this.selectedCode.id : 0,"range-date":_vm.rangeDateValue,"supplier-id":(this.selectedSupplier) ? this.selectedSupplier.id : 0}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }